import { useMutation } from "react-query";
import { post } from "./http";
import { fetchActiveGrid } from "./shop_grid";
import { Api } from "./types";

const copyToProposal = (activeGrid: Api.ShopGrid, name: string) => ({
  shop: activeGrid.shop!,
  isActive: false,
  name,
  width: activeGrid.width || 0,
  height: activeGrid.height || 0,
  shopGridCells: activeGrid.shopGridCells
    .map((cell) => ({
      yAxis: cell.yAxis,
      xAxis: cell.xAxis,
      shelvesCount: 1,
      isHighlight: false,
      shopGridCellSections: cell.shopGridCellSections.map((section) => ({
        sectionIndex: section.sectionIndex,
        shopGridCellSectionInventories: section.shopGridCellSectionInventories.map((inventory) => ({
          inventoryIndex: inventory.inventoryIndex,
          quantity: inventory.quantity,
          subFamily: inventory.subFamily.id,
        })),
      })),
    })),
});

const useGridProposalCreate = () =>
  useMutation(async ({ erpId, name }: { erpId: string; name: string }) => {
    const activeGrid = await fetchActiveGrid(erpId);
    if (!activeGrid) throw new Error("Can not create proposal, no active grid found for this shop");

    return post("/shop_grids", copyToProposal(activeGrid, name));
  });

export { useGridProposalCreate };
